module.exports = __webpack_public_path__ + "img/Campus_Central_vista_dron-xl.8792c2c4.webp";